module.exports = __webpack_public_path__ + "img/logo-abes-blanc.afc10546.svg";